import React, { Component } from 'react';

import '../../../../chat.css';
import MessageType from '../../../../config/constants/MessageTypeEnum'
import TextMessage from './textMessage/TextMessage';
import ImageMessage from './imageMessage/ImageMessage';
import LinkMessage from './linkMessage/LinkMessage';
import VideoMessage from './videoMessage/VideoMessage';
import CardMessage from "./cardMessage/CardMessage";
import FileMessage from "./fileMessage/FileMessage";
import LayoutTypeEnum from "../../../../config/constants/LayoutTypeEnum";

/**
 * Class for a message that acts as a component switch.
 * Here depending on the MessageType enum, the correct component for a specific message type is shown.
 */
class Message extends Component {
    render() {
        return(
            <div className={this.props.layoutMode === LayoutTypeEnum.searchBot ? 'search-bot-message-container' : 'message-container'}>
                {
                    {
                        [MessageType.text]: <TextMessage content={this.props.message.content} layoutMode={this.props.layoutMode}/>,
                        [MessageType.link]: <LinkMessage isSuggestion={this.props.isSuggestion } isUser={this.props.isUser} hover={this.props.hover} title={this.props.message.title} url={this.props.message.url} chatConfig={this.props.chatConfig}/>,
                        [MessageType.image]: <ImageMessage url={this.props.message.url}/>,
                        [MessageType.video]: <VideoMessage url={this.props.message.url} autoPlay={this.props.message.autoPlay} 
                                                           loop={this.props.message.loop} showControls={this.props.message.showControls}/>,
                        [MessageType.card]: <CardMessage title={this.props.message.title} subtitle={this.props.message.subtitle}
                                                         imageUrl={this.props.message.imageUrl} linkUrl={this.props.message.linkUrl}
                                                         linkButtonTitle={this.props.message.linkButtonTitle}/>,
                        [MessageType.file]: <FileMessage isUser={this.props.isUser} downloadFile={this.props.downloadFile} title={this.props.message.filename} url={this.props.message.url} chatConfig={this.props.chatConfig}/>,
                    }[this.props.message.messageType]
                }
            </div>
        );
    }
}

export default Message;
